import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-list-arrow",
  "use": "icon-list-arrow-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-list-arrow\">\n  <defs>\n    <style>\n      #icon-list-arrow .cls-1 {\n        fill-rule: evenodd;\n      }\n    </style>\n  </defs>\n  <path id=\"icon-list-arrow_圆角矩形_4\" data-name=\"圆角矩形 4\" class=\"cls-1\" d=\"M5.384,18.757C5.115,18.489,4.832,18.249,4.55,18l7.9-7.9L4.55,2.2c0.281-.245.565-0.485,0.834-0.753l0.621-.621L15.283,10.1,6.005,19.378Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/list-arrow.svg
// module id = b4xV
// module chunks = 76